"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMetrica = void 0;
const react_1 = require("react");
const YandexMetricaProvider_1 = require("../components/YandexMetricaProvider");
const ym_1 = require("../lib/ym");
const useMetrica = () => {
    const tagID = (0, react_1.useContext)(YandexMetricaProvider_1.MetricaTagIDContext);
    const notBounce = (0, react_1.useCallback)((options) => {
        (0, ym_1.ym)(tagID, 'notBounce', options);
    }, [tagID]);
    const reachGoal = (0, react_1.useCallback)((target, params, callback) => {
        (0, ym_1.ym)(tagID, 'reachGoal', target, params, callback);
    }, [tagID]);
    const setUserID = (0, react_1.useCallback)((userID) => {
        (0, ym_1.ym)(tagID, 'setUserID', userID);
    }, [tagID]);
    const userParams = (0, react_1.useCallback)((parameters) => {
        (0, ym_1.ym)(tagID, 'userParams', parameters);
    }, [tagID]);
    const ymEvent = (0, react_1.useCallback)((...parameters) => {
        (0, ym_1.ym)(tagID, ...parameters);
    }, [tagID]);
    return { notBounce, reachGoal, setUserID, userParams, ymEvent };
};
exports.useMetrica = useMetrica;
//# sourceMappingURL=useMetrica.js.map